// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3g5KG","selects":"Documents_selects__3RCvO"};